import { MIN_BANNER_ITEMS } from './constants';

const DISPLAY_NAME = 'Banner Carousel 2';

/**
 * Validates a Banner Carousel 2 slice for both storefront and aisle editors.
 *
 * @param {Object} slice - Banner carousel data
 * @param {number} position - 1-based position used in error messages
 * @returns {string[]} Validation messages
 */
export function validateBannerCarousel2(slice, position) {
    const errors = [];
    const items = slice.items ?? [];

    if (items.length < MIN_BANNER_ITEMS) {
        errors.push(`${DISPLAY_NAME} (position ${position}) requires at least ${MIN_BANNER_ITEMS} banner items.`);
    }

    if (items.some((item) => !item.imageUrl)) {
        errors.push(`${DISPLAY_NAME} (position ${position}) has missing images.`);
    }

    if (items.some((item) => item.linkText?.trim() && !item.linkUrl?.trim())) {
        errors.push(`${DISPLAY_NAME} (position ${position}) requires a link URL if CTA text is provided.`);
    }

    if (slice.eyebrow && !slice.heading) {
        errors.push(`${DISPLAY_NAME} (position ${position}) requires a heading when an eyebrow is provided.`);
    }

    return errors;
}
